<template>
  <div class="views-wrap" @scroll="headerScrollControl">
    <Header />
    <Dialog />
    <LoaderComponent />
    <Transition name="slide-fade">
      <RouterView />
    </Transition>
  </div>
</template>
<script>
import { nextTick, onMounted, watch } from 'vue'
import { useRoute, RouterView } from 'vue-router'
import Header from '@/components/layout/Header.vue'
import Dialog from './components/component/Dialog.vue'
import LoaderComponent from './components/component/LoaderComponent.vue'

export default {
  name: 'PageComponent',
  components: {
    RouterView,
    Header,
    Dialog,
    LoaderComponent
  },
  setup () {
    const route = useRoute()

    const headerScrollControl = () => {
      // scroll시 아래 라인 및 섀도우 추가
      const headerWrap = document.getElementsByClassName('header-wrap')
      if (headerWrap && headerWrap.length > 0) {
        const header = headerWrap[0]
        if (window.scrollY > 0) {
          header.classList.add('header-shadow')
        } else {
          header.classList.remove('header-shadow')
        }
      }
    }
    onMounted(() => {
      document.addEventListener('scroll', headerScrollControl)
    })
    watch(route, async () => {
      await nextTick()
      window.scrollTo({ top: 0, behavior: 'instant' })
    })

    return { route, headerScrollControl }
  }
}
</script>

<style lang="scss">
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard-dynamic-subset.css');
@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@700&display=swap');
@import '@/assets/styles/commonStyle.scss';
body,
html {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overscroll-behavior: contain;
}
div,
span,
h1,
h2,
h3,
h4,
h5,
h6,
p,
input,
button a,
ul,
li,
fieldset,
form,
label,
legend,
textarea,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
footer,
header,
nav,
section {
  padding: 0;
  margin: 0;
  touch-action: manipulation;
}
.views-wrap {
  box-sizing: border-box;
  /* position: relative; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 480px;
  min-height: 100svh;
  margin: auto;
  transition: transform 250ms ease-out;

  @supports not (height: 100svh) {
    height: calc(100vh - 75px);
  }
}
</style>
